<ng-container *ngIf="suggestion">
    <!-- <ng-container *ngIf="!isInView; else component">
        <div  [class.mb--96]="!isInView">
             <loader-report [position]="'bottom'"></loader-report>
        </div>
    </ng-container>
    <ng-template #component> -->
        <section class="products-related mb--96" >
            <div class="row">
                <div class="col-12 flex-column d-flex  gap-12 p--0">
                    <div class="question fw" [class.problem_set]="show_solution">
                        <h4 class="product-section-title mat-primary mat-text-primary" >
                            <ngx-typed-writer [strings]="[suggestion.problem_name]" [cursorChar]="'|'"
                            [showCursor]="false" [typeSpeed]="30" [loop]="false" (completeLoop)="show_solution = true"> </ngx-typed-writer>
                        </h4>
                    </div>
                    <div class="solution">
                        <ngx-typed-writer *ngIf="show_solution" [strings]="[suggestion.problem_description]" [startDelay]="1500" [cursorChar]="'|'"
                            [showCursor]="true" [typeSpeed]="10" [loop]="false" (completeLoop)="complete();"> </ngx-typed-writer>
                    </div>
                </div>

                <div class="col-12 products-suggested">
                    <ng-container *ngIf="show_products">
                         <!-- <div *ngIf="isInView" [@fadeInLeft]>mostrami</div> -->
                        <h4 class="mt--24" [@fadeInUp] [ngStyle]="{ 'animation-delay': '1s' }">{{ 'Soluzione individuate' | translate }}</h4>
                        <ngx-delfi-products-list *ngIf="show_products" [groupby]="'none'" [products]="suggestion.suggestion" [template]="'list'"
                        [submissionsidebar]="true" [showFilters]="false"></ngx-delfi-products-list>
                 </ng-container>
                </div>
            </div>
        </section>
    <!-- </ng-template> -->
</ng-container>